import React, { useCallback, useMemo } from 'react';
import { useHistory, useLocation, Route, Switch, Redirect } from 'react-router-dom';

import navbarReduce from '../../shared/data/navbar/navbarReduce';
import Page from 'Components/Page';
import TabInvoiceDetail from './components/TabInvoiceDetail';
import withAuthentication from 'Components/withAuthentication';
import ReactGA from 'Shared/analytics';

const InvoiceDetail = ({ profileData }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const tabRouter = (
    <>
      <Route path="/customer/invoice/" exact render={() => <Redirect to="/customer/invoice/detail/" />} />
      <Switch>
        <Route path="/customer/invoice/detail/:id" component={TabInvoiceDetail} />
      </Switch>
    </>
  );

  const activeTabId = useMemo(() => {
    return pathname.split('/')[3];
  }, [pathname]);

  const handleTabClick = useCallback(
    (tabClicked) => {
      if (tabClicked !== activeTabId) {
        history.replace(`/customer/invoice/${tabClicked}/`);
        ReactGA.pageview(`/customer/invoice/${tabClicked}/`, 'Invoice detail' + tabClicked);
      }
    },
    [history, activeTabId]
  );

  return (
    <Page
      props={{
        titleProps: {
          text: 'Invoices',
        },
        navigation: {
          variant: 'tabs',
          tabsProps: {
            tabs: [
              {
                id: 'detail',
                label: '',
              },
            ],
            onTabClick: handleTabClick,
            activeTabId,
          },
        },
        navbarProps: {
          points: navbarReduce(profileData),
          activePointId: 'invoice',
        },
        content: tabRouter,
      }}
    />
  );
};

export default withAuthentication(InvoiceDetail);
